export type LessonUrlParams = {
  lessonId: number | string;
  slugCourseName?: string;
  blockId?: number | string;
};

export const buildLessonUrl = (params: LessonUrlParams): string => {
  const { blockId, slugCourseName, lessonId } = params;
  if (blockId && slugCourseName) {
    return `courses/${slugCourseName}/lesson-blocks/${blockId}/lessons/${lessonId}/`;
  }

  if (slugCourseName) {
    return `courses/${slugCourseName}/lessons/${lessonId}/`;
  }

  return `lessons/${lessonId}/`;
};
